<template>
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 25H8C6.89543 25 6 24.1046 6 23V7C6 5.89543 6.89543 5 8 5H13" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20 19L24 15L20 11" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M24 15H12" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>